module.exports = __webpack_public_path__ + "img/e-auto.49682581.jpg";